import React, { useEffect, useState } from "react";
import "../Components/Banner.css";

const Banner = ({ title, backgroundImage }) => {
  const [bg, setBg] = useState("");

  useEffect(() => {
    setBg(backgroundImage); // Forces a re-render
  }, [backgroundImage]);

  return (
    <div 
      className="topBanner" 
      style={{ backgroundImage: `url(${bg})` }}
    >
      <div className="bannerOverlay"></div>
      <h1 className="bannerTitle">{title}</h1>
    </div>
  );
};

export default Banner;
